/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import LearnUtilsHome from './LearnUtils';
import {setForceHideNavbar} from '../../actions/appActions';
import {connect} from 'react-redux';

import {LearnTutorialPage, DiscoverUtils, LearnUtils} from 'discover-hub';
import DiscoverAnalytics from '../../../utils/DiscoverAnalytics';

const analytics = new DiscoverAnalytics();

/* eslint-enable no-unused-vars */
import './Learn.scss';
import {DeviceDetectionUtil} from 'cchome-shared/utils';

interface Props {
	locale: string;
	env: string;
	match: any;
	setForceHideNavbar: Function;
	forceHideNavbar: boolean;
	history: any;
	location: any;
	profile: {
		productEntitlements: Array<string>;
		subscriptionInfo: Object;
		profileFetchFinished: boolean;
	};
	intl: any;
}

interface State {
	app: string;
	pageIndex: number;
}

class LearnDiscoverTutorialPage extends Component<Props, State> {
	/**
	 * [getPathData grabs the relveant learn fields from the url]
	 * @returns {[none]}
	 */
	getPathData() {
		let pathParams = this.props.match.url.split('/');

		pathParams = pathParams.filter(param => param); // filter out empty strings

		const indexOfLearn = pathParams.indexOf('learn');

		const app = pathParams[indexOfLearn + 1];
		const field = pathParams[indexOfLearn + 3];
		const playlist = pathParams[indexOfLearn + 4];
		const playlistID = `${app}/${field}/${playlist}`;
		const tutorialPath = `${app}/${pathParams[indexOfLearn + 5]}`;
		const tutorialID = app !== 'rush' ? tutorialPath : `premiere-${tutorialPath}`;

		// return {
		// 	app : path[3],
		// 	level: path[4],
		// 	field: path[5],
		// 	playlistTitle: path[6],
		// 	tutorialTitle: path[7]
		// };

		return {
			playlistID,
			tutorialID,
			app,
		};
	}

	componentDidMount() {
		// this.props.setForceHideNavbar(true);
	}

	componentWillUnmount() {
		// this.props.setForceHideNavbar(false);
	}

	/**
	 * Callback function for Learn component when route changes.
	 *
	 */
	onLearnPathChange(learnSignal) {
		let newPath = this.props.location.pathname;
		const newState: any = {};
		let isTutorial = false;
		const signalValue = learnSignal.value;

		if (learnSignal.type === 'tutorial') {
			isTutorial = true;
			const beforeLearn = newPath.split('/learn')[0];
			const extraPath = `${signalValue.app}/${signalValue.level}/${signalValue.field}/${signalValue.playlistId}/${signalValue.tutorialId}`;
			newPath = `${beforeLearn}/learn/${extraPath}`;
		}
		else if (learnSignal.type === 'app') {
			const beforeLearn = newPath.split('/learn')[0];
			let extraPath = `${signalValue.app}`;
			if (signalValue.level) {
				const queryParams = DiscoverUtils.getSearchPath({
					experienceLevel: signalValue.level,
				});

				extraPath = `${extraPath}/${queryParams}`;
			}
			newPath = `${beforeLearn}/learn/app/${extraPath}`;

			newState.app = signalValue.app;
			// newState.pageIndex = this.state.pageIndex;
		}

		if (isTutorial) {
			this.props.history.push({
				pathname: `${newPath}`,
			});
		}
		else {
			this.setState(newState); // TODO: put this back in later when
			// we actually have real server calls to re-render data
			this.props.history.push(newPath);
		}
	}

	render() {
		let locale = this.props.locale;
		if (!LearnUtils.isValidLearnLanguage(this.props.locale)) {
			// return (
			// 	<LearnLanguagePicker locale={this.props.locale}/>
			// );
			locale = 'en';
		}

		const pathObject = this.getPathData();

		if (DeviceDetectionUtil.isInternetExplorer()) {
			return (
				<div className='ie-error-page'>
					<p>{this.props.intl.formatMessage({id: 'app.ie11.error.message'})}</p>
				</div>
			);
		}

		if (this.props.locale && this.props.profile.profileFetchFinished) {
			return (
				<div className='learn-tutorialPage'>
					<LearnTutorialPage
						env={this.props.env}
						imsData={LearnUtilsHome.getIMSData()}
						locale={locale}
						featureFlags={window.cchome.util.getAllFeatures()}
						playlistInfo={this.getPathData()}
						app={pathObject.app}
						playlistID={pathObject.playlistID}
						tutorialID={pathObject.tutorialID}
						signedIn
						onLearnPathChange={data => this.onLearnPathChange(data)}
						intl={this.props.intl}
						logger={window.cchome.util.logger}
						postAnalytics={data => analytics.postCustomData(data)}
						trackingService={window.trackingService}
					/>
				</div>
			);
		}
		return <div className='learn-tutorialPageEmpty' />;
	}
}

function mapStateToProps(state) {
	return {
		forceHideMenu: state.app.forceHideMenu,
		leftNavOpen: state.app.leftNavOpen,
		forceHideNavbar: state.app.forceHideNavbar,
		profile: state.profile,
	};
}

export default connect(mapStateToProps, {setForceHideNavbar})(injectIntl(LearnDiscoverTutorialPage));
